import React, { useState, useEffect } from 'react';
import './index.scss';
import * as imageUtil from '@umu/umu-image-handle';
import { If } from 'common/src/components';
import { InputSearch } from '../Input';
import { searchUserList } from '../../server';
import { ISearchInputItem, IUserSearchInputProps } from '../../interface';
import { getAvatarBackgroundColor, getAvatarWord } from '../../../@loadAvatar/loadAvatarUtil';
import { IconClose } from '../icon';

export const UserSearchInput = (props: IUserSearchInputProps) => {
    const [selectList, setSelectList] = useState<ISearchInputItem[]>([]);
    const [defaultValue, setDefaultValue] = useState('');
    useEffect(() => {
        setSelectList([]);
        setDefaultValue('');
    }, [props.isClear]);
    const [pageInfo, setPageInfo] = useState<IPageInfo>({
        current_page: 1,
        list_total_num: 0,
        total_num: 0,
        size: 50,
        total_page_num: 0,
    });
    const getList = async (val: string, page?: number) => {
        if (val === '') {
            return [];
        }
        setDefaultValue(val);
        const result = await searchUserList({
            keyword: val,
            page: page || 1,
            size: pageInfo.size,
        });
        const { list, page_info } = result;
        setPageInfo(page_info);
        const pre: ISearchInputItem[] = [];
        for (let i = 0; i < list.length; i++) {
            pre.push({
                icon: list[i].avatar || '',
                title: list[i].user_name || list[i].phone || list[i].email,
                label: list[i].email,
                id: list[i].id,
            });
        }
        return pre;
    };
    const renderChildren = (item: ISearchInputItem) => {
        return <span>{'"' + item.title + '"' + (item.label && item.label !== '' ? '<' + item.label + '>' : '')}</span>;
    };
    const setData = (list: ISearchInputItem[]) => {
        setSelectList(list);
        if (props.onChange) {
            const ids = [];
            for (let i = 0; i < list.length; i++) {
                ids.push(list[i].id);
            }
            props.onChange(ids);
        }
    };
    const onSelect = (item: ISearchInputItem) => {
        const pre: ISearchInputItem[] = [...selectList];
        pre.push(item);
        setData(pre);
    };
    const closeClick = (count: number) => {
        const pre: ISearchInputItem[] = [...selectList];
        pre.splice(count, 1);
        setData(pre);
    };
    const renderData = (item: ISearchInputItem, num: number) => {
        const isHasIcon = !!item?.icon;
        return (
            <span className="render-wrap" key={`member-list-${num}`}>
                <div className="img" style={{ backgroundColor: isHasIcon ? '' : getAvatarBackgroundColor(item.id) }}>
                    <If condition={isHasIcon}>
                        <img src={imageUtil.appendWidth(item.icon, 100)} className="loaded" />
                    </If>
                    <If condition={!(item.icon && item.icon !== '')}>
                        <div className="avatar-word">{getAvatarWord(item.title)}</div>
                    </If>
                </div>
                <div className="user-search-title">
                    <span className="title-text" title={item.title}>
                        {item.title}
                    </span>
                    <span
                        className="icon-close-member"
                        onClick={() => {
                            closeClick(num);
                        }}
                    >
                        <IconClose />
                    </span>
                </div>
            </span>
        );
    };
    return (
        <InputSearch
            hideOnMouseLeave={props.hideOnMouseLeave}
            isHideBorder={props?.isHideBorder}
            placeholder={props.placeholder}
            getList={getList}
            defaultValue={defaultValue}
            maxCount={props.limitMax}
            selectList={selectList}
            onSelect={onSelect}
            pageInfo={pageInfo}
            renderData={renderData}
            renderChildren={renderChildren}
            className="toolbar-input"
        />
    );
};
